import { observer } from "mobx-react-lite";

import { useStore } from "@/store";
import { twMerge } from "@/utils/twMerge";

import { Members } from "./members/Members";
import { PlanBilling } from "./plan-billing/PlanBilling";
import { UpdateTeamForm } from "./update-team-form/UpdateTeamForm";
import { UpdateUserForm } from "./update-user-form/UpdateUserForm";

const TeamDialogContentBody = observer(function TeamDialogContentBody() {
  const { activeTab, team, billing } = useStore().dialog.teamDialog;

  if (activeTab === "account") return <UpdateUserForm />;
  if (activeTab === "settings") return <UpdateTeamForm key={team?.uid} />;
  if (activeTab === "members") return <Members key={team?.uid} />;
  if (activeTab === "billing" && billing) return <PlanBilling billing={billing} />;

  return null;
});

export function TeamDialogContent() {
  return (
    <div
      className={twMerge(
        "flex flex-col flex-1 min-w-0 overflow-y-auto no-scrollbar rounded-8 p-5 bg-gray-100 dark:bg-zinc-900",
        "sm:overflow-visible sm:p-2.5",
      )}
    >
      <TeamDialogContentBody />
    </div>
  );
}
